import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-department-resources-dialog.controller';
import template from './edit-department-resources-dialog.html';

// Validation
import assessmentDepartmentResourceMessagesTpl from './messages/assessment.DepartmentResource.messages.html';
import assessmentDepartmentResourceOtherMessagesTpl from './messages/assessment.DepartmentResource.other.messages.html';


class dialogService {
  getOptions($event, { departmentResources }) {
    return {
      controller,
      controllerAs: 'editDepartmentResourcesDialogVM',
      locals: {
        departmentResources
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editDepartmentResourceDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editDepartmentResourceDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put(
      'assessment.DepartmentResource.messages.html', assessmentDepartmentResourceMessagesTpl
    );
    $templateCache.put(
      'assessment.DepartmentResource.other.messages.html', assessmentDepartmentResourceOtherMessagesTpl
    );
  })
  .name;
